import { createTheme } from '@mui/material/styles';

export function fluidify(prop: string, range: { min: string; max: string }) {
  const { min, max } = range;
  const { values, up } = createTheme().breakpoints;
  const canvas = { min: values.xs, max: values.xl };
  const minVal = parseInt(min, 10);
  const maxVal = parseInt(max, 10);

  return {
    [prop]: min,
    [up('xs')]: {
      [prop]: `calc(${min} + ${maxVal - minVal} * (100vw - ${canvas.min}px) / ${canvas.max - canvas.min})`,
    },
    [up('xl')]: {
      [prop]: max,
    },
  };
}
